import React, { useState } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { html } from "@codemirror/lang-html";
import DOMPurify from "dompurify";
import { Row, Col } from "antd";

export default function HtmlEditorWithPreview(props) {
  const {setHtmlCode, htmlCode, description} =props


return (
  <div style={{ marginBottom: "20px" }}>
    <h3>{description}</h3>

    <Row gutter={24} style={{ marginTop: "10px" }}>
      <Col xs={24} md={12}>
        <h2>HTML Editor</h2>

        <CodeMirror
          value={htmlCode}
          height="500px"
          extensions={[html()]}
          theme="dark"
          onChange={(value) => setHtmlCode(value)}
        />
      </Col>

      <Col xs={24} md={12}>
      <h2 style={{
        marginBottom: "10px",
      }}>Live Preview</h2>
        <div
          style={{
            backgroundColor: "#fff",
            color: "#0a0a0a",
            padding: "10px",
            border: "1px solid #ccc",
            maxHeight: "500px",
            minHeight: "500px",
            overflowX: "auto",
             overflowY: "auto"
          }}
        >
          

          <div
            style={{
              marginTop: "10px",
            }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(htmlCode),
            }}
          />
        </div>
      </Col>
    </Row>
  </div>
);
}
